// About.js
import React from 'react';
import pic from "../assets/profile.png";
import './About.css';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
// import { faGithub, faDropbox } from '@fortawesome/free-brands-svg-icons';
// import { library } from '@fortawesome/fontawesome-svg-core';
import githubIcon from "../assets/github-brands-solid.svg";
import twitterIcon from "../assets/twitter-brands-solid.svg";
import googleScholarIcon from "../assets/google-scholar-brands-solid.svg"; 


// library.add(faGraduationCap, faGithub, faDropbox);


const About = () => {
  return (
    <div className="page-background"> 
    <div className="about-container">
      <div className="about-left">
        <img  
          src={pic} 
          alt="headshot"  
          className="about-image" 
        />
        <div className="contact-info">
          <a href="mailto:simarora@caltech.edu" className="email-link">
            simarora@caltech.edu
          </a>
          <div className="social-links"> 
            <a 
              href="https://scholar.google.com/citations?user=rGRsWH8AAAAJ"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src={googleScholarIcon} 
                alt="Google Scholar"
                className="icon-image"
              />
            </a>
            <a 
              href="https://github.com/simran-arora"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src={githubIcon} 
                alt="GitHub"
                className="icon-image"
              />
            </a>
            <a 
              href="https://x.com/simran_s_arora"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src={twitterIcon} 
                alt="Twitter"
                className="icon-image"
              />
            </a>
            <a 
              href={require("../assets/Simran_Arora_CV.pdf")}
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              CV
            </a>
          </div>
        </div>
      </div>
      
      <div className="about-right">
        {/* <h1 className="about-name">Simran Arora</h1> */}
        <div className="about-text">
            Hi, I'm Simran. I am an incoming assistant professor at <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://www.cms.caltech.edu/">Caltech Computing + Mathematical Sciences</a> and lead the Frontier Performance team at <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://www.together.ai/">Together AI</a> as SVP of Research (hiring!).
            I am also an advisor to <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://cartesia.ai/">Cartesia</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://engram.com/">Engram</a>, and <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://fearn.ai/">Fearn</a>. <br/><br/>
               
            My research focuses on understanding and expanding the Pareto frontier between AI quality, memory, and compute. Ideally, we can give AI developers simple and principled tools to navigate these tradeoffs. For instance, the theoretical analysis and algorithms across <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://arxiv.org/abs/2312.04927">Zoology</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://www.together.ai/blog/based">Based</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://arxiv.org/abs/2407.05483">Just read twice</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://hazyresearch.stanford.edu/blog/2025-06-08-cartridges">Cartridges</a>, and <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://arxiv.org/abs/2210.02441">Ask me anything</a> serve to characterize the tradeoffs for in-context learning with foundation models. To make it easier for AI developers to map theoretical efficiency wins to wall-clock efficiency wins across hardware platforms, I also develop tools like <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://github.com/HazyResearch/ThunderKittens">ThunderKittens</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://hazyresearch.stanford.edu/blog/2025-11-09-hk">HipKittens</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://hazyresearch.stanford.edu/blog/2025-11-17-pk">ParallelKittens</a>, <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://hazyresearch.stanford.edu/blog/2025-05-27-no-bubbles">Megakernels</a>, and <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://arxiv.org/abs/2502.10517">KernelBench</a>. <br/><br/>
            
            I created and taught Stanford's <a class="abt_a" target= "_blank" rel="noopener noreferrer" href="https://cs229s.stanford.edu/fall2023/">systems for machine learning (CS 229s)</a> course in Fall 2023.<br/><br/>
            </div>
      </div>
    </div>
    </div>
  );
};
export default About;

